<template>
	<section class="container marketing-section">
		<h2 class="heading-1 text-align-center mb-250"> Fund features </h2>
		<MarketingSiteCardRow title-size="heading-6" description-size="body-md" :cards="cards" theme="light" />
	</section>
</template>

<script setup lang="ts">
import { MarketingSiteCard } from 'types/marketing-site';
import MarketingSiteCardRow from '@components/marketing-site/marketing-site-card-row.vue';

const cards: Array<MarketingSiteCard> = [
	{
		title: 'Targeting a once-in-a-decade lending environment',
		description:
			'Rapidly rising interest rates and a potential liquidity crisis creates a rare and advantageous environment for well-capitalized private credit investors.'
	},
	{
		title: 'Concentrating within high-growth markets',
		description:
			'The fund will primarily target fast-growing Sunbelt markets like Dallas-Fort Worth, Atlanta, Phoenix, Orlando, Tampa, and Charleston.'
	},
	{
		title: 'Focusing on high-quality assets with creditworthy borrowers',
		description:
			'The fund aims to provide rescue capital to high-end borrowers experiencing circumstantial liquidity needs.'
	},
	{
		title: 'Leveraging Fundrise’s billion-dollar experience and relationships',
		description:
			'Fundrise has acquired or financed 37,000+ residential units and made more than 71 unique mezzanine and preferred equity investments, collectively worth over $7 billion.'
	}
];
</script>
